module.exports = __webpack_public_path__ + "img/GSB.9aad222.png";